import { makeAutoObservable } from 'mobx'
import { openApi, request } from '../../../../helpers/request'

class shopProductStatusesController {
    constructor() {
        makeAutoObservable(this)
    }

    statuses = []
    status = {}

    createStatus() {
        this.clearStatus()
        this.status = {
            id: 0,
            name: '',
            colorhex: '7264D6'
        }
        this.statuses.unshift(this.status)
    }

    onSubmit(e) {
        e.preventDefault()

        let data = new FormData()
        data.append('name', this.status.name)
        data.append('colorhex', this.status.colorhex)
        data.append('viewcart', this.status.viewcart ? this.status.viewcart : 0)
        data.append('viewmain', this.status.viewmain ? this.status.viewmain : 0)

        let statusID = this.status.id && this.status.id > 0 ? this.status.id : 0

        request('post', '/shop/status/' + statusID + '/', data, true).then(
            (response) => {
                console.log(response)
                this.getAllStatuses()
                this.clearStatus()
            }
        )
    }

    clearStatus() {
        this.status = {}
    }

    onChangeSwitch(key, value) {
        let e = 0
        if (value) {
            e = 1
        }
        this.onChangeStatus(key, e)
    }

    selectStatus(statusID) {
        request('get', '/shop/status/' + statusID + '/', {}, true).then(
            (response) => {
                this.status = response.data
            }
        )
    }

    onChangeStatus(key, value) {
        this.status[key] = value.replace('#', '')
        console.log(this.status[key])
    }

    getAllStatuses() {
        openApi('get', '/products/types', {})
            .then((success) => {
                this.statuses = success.data
            })
    }

    deleteStatus(statusID) {
        request('delete', '/shop/status/' + statusID + '/', {}, true)
            .then((response) => {
                this.getAllStatuses()
            }
        )
    }
}

export default new shopProductStatusesController()
